export const getformattedDate = (date: string) => {
  return new Date(date)
    .toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    .replace(/(\d+) (\w+), (\d+)/, '$2 $1, $3');
};
